import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';

import Checkbox from '@material-ui/core/Checkbox';

export interface IOnChangeableCheckbox {
    onChange: (checked: boolean) => void;
}

interface CheckboxWrapperProps extends FieldRenderProps<any, any>{
    onChangeable?: IOnChangeableCheckbox;
}

export const CheckboxWrapper: React.FunctionComponent<CheckboxWrapperProps> = ({
    input: { checked, name, onChange: onInputChange, value, ...restInput },
    meta,
    onChangeable,
    onChange,
    ...rest
}) => {

    const onChangeCombined = React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checkedValue: boolean) => {
        if (onChange) {
            onChange(event, checkedValue);
        }

        onInputChange(checkedValue);
    }, [onChange, onInputChange]);

    return <Checkbox
        {...rest}
        name={name}
        inputProps={restInput}
        onChange={onChangeCombined}
        checked={value ? true : false}
    />
}